module.exports = __webpack_public_path__ + "img/arrow-up.a9aa71f3.svg";